import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Label } from '../../components/ui/label';
import { Switch } from '../../components/ui/switch';
import { toast } from '../../hooks/use-toast';
import { errorMessage } from '../errors';
import { notificationPrefsApi } from '../notificationPrefsApi';

// One switch per staff email a user may turn on or off. Each seat sets its own.
export default function EmailPrefsSection() {
  const [types, setTypes] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    notificationPrefsApi.getEmailPrefs()
      .then((d) => setTypes(d.types))
      .catch((e) => toast({ title: 'Could not load email settings', description: errorMessage(e) }));
  }, []);

  const flip = async (event_type, label, enabled) => {
    setSaving(true);
    try {
      const saved = await notificationPrefsApi.setEmailPrefs({ [event_type]: enabled });
      setTypes(saved.types);
      toast({ title: `${label}: email ${enabled ? 'on' : 'off'}` });
    } catch (e) {
      toast({ title: 'Could not save email settings', description: errorMessage(e) });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-5 max-w-lg space-y-3" data-testid="email-prefs">
      <div>
        <h2 className="font-serif text-lg font-bold" style={{ color: '#070B5F' }}>Email notifications</h2>
        <p className="text-sm text-slate-500 mt-1">
          Choose which of these also reach your inbox. Sign-in, password and other security emails always arrive. This is only your own email.
        </p>
      </div>
      {types === null ? (
        <div className="flex items-center text-slate-400 text-sm" data-testid="email-prefs-loading">
          <Loader2 className="animate-spin mr-2" size={16} /> Loading...
        </div>
      ) : types.map(({ event_type, label, enabled }) => (
        <div key={event_type} className="flex items-center gap-3">
          <Switch id={`email-${event_type}`} checked={enabled} onCheckedChange={(c) => flip(event_type, label, c)}
            disabled={saving} data-testid={`email-${event_type}`} />
          <Label htmlFor={`email-${event_type}`} className="text-sm">{label}</Label>
        </div>
      ))}
    </div>
  );
}
